import React from "react";
import "../Sales/Sales.css";

import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import invoiceImg from "../../../assets/images/State-Distributor/viewInvoice.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData1(productCode, product, uom, qty, price, total, gst, final) {
  return {
    productCode,
    product,
    uom,
    qty,
    price,
    total,

  };
}

const rows1 = [
  createData1(
    "004",
    "Royal Green",
    "10L",
    "4",
    "₹600",
    "₹2,400",
 
  ),
];

export const ViewDistributorInvoice = () => {
  return (
    <div className="salesContainer">
      <div className="container">
        <div className="d-flex gap-1 mb-2">
          <span className="me-2">
            <Link to="/sub-invoice" style={{ color: "black" }}>
              <FaArrowLeftLong />
            </Link>
          </span>
          <div className="addModalTitle">View Invoice</div>
        </div>
        <div className="invoiceContainer">
          <div className="invoiceContent">
            <div>QT-2025-031</div>
            <div>09/09/2025</div>
          </div>
          <div className="invoiceContent">
            <div>State Distributor</div>
            <div>
              <span>96/854, Uppal,</span>
              <br />
              <span>Hyderabad, Telangana.</span>
              <br />
              <span>8523697410, 6363632501</span>
              <br />
            </div>
          </div>
          <div className="invoiceImg">
            <img src={invoiceImg} />
          </div>
        </div>
        <div className="invoiceAddress">
          <div>Billed To:</div>
          <div style={{ color: "var(--color-font-primary)", fontWeight: "600" }}>AP Paints Distributor,</div>
          <div>Sy no: 85/7, Kukatpally,</div>
          <div>Hyderabad, Telangana.</div>
          <div>9632587410</div>
        </div>
        {/* table  */}

        <div className="dashboardTableContainer">
          <TableContainer component={Paper}>
            <Table
              // sx={{ minWidth: 650 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead className="dashboadTableHeader">
                <TableRow>
                  <TableCell align="left">Product Code</TableCell>
                  <TableCell align="left">Product Name</TableCell>
                  <TableCell align="left">UOM</TableCell>

                  <TableCell align="left">Qty</TableCell>
                  <TableCell align="left">Price/Unit (₹)</TableCell>
                  <TableCell align="left">Total (₹)</TableCell>
                 
                </TableRow>
              </TableHead>
              <TableBody>
                {rows1.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    className="dashboardTableBody"
                  >
                    <TableCell align="left">{row.productCode}</TableCell>
                    <TableCell align="left">{row.product}</TableCell>
                    <TableCell align="left">{row.uom}</TableCell>

                    <TableCell align="left">{row.qty}</TableCell>

                    <TableCell align="left">{row.price}</TableCell>
                    <TableCell align="left">{row.total}</TableCell>
                    
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {/* Totals */}
        <div className="addModalTotalContainer">
          <div>
            <div className="addModalContent">
              <span>Total Products:</span>
              <span>40 nos</span>
            </div>
          
            <div className="addModalContent">
              <span>Total Value:</span>
              <span>₹20,000</span>
            </div>
            <div className="addModalContent">
              <span>Amount Paid:</span>
              <span>₹2,450</span>
            </div>
            <div className="addModalContent">
              <span>Payment Status:</span>
              <span style={{ color: "#10B981" }}>Paid</span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end">
          <div
            className="addModalButtons"
            style={{ marginTop: "20px", display: "flex", gap: "20px" }}
          >
            <button className="addBtnCancel">Close</button>
            <button className="addBtnSave">Print Invoice</button>
          </div>
        </div>
      </div>
    </div>
  );
};
